<template>
    <article class="py-60 px-20 md:grid md:grid-cols-12 md:gap-x-20 md:px-0">
        <div class="md:col-span-8 md:col-start-3">
            <component :is="'script'"
                       v-if="model.scriptUrl"
                       id="CookieDeclaration"
                       :src="model.scriptUrl"
                       type="text/javascript"
                       :data-culture="culture"/>
        </div>
    </article>
</template>

<script lang="ts">
import { CookieBlock } from '@/api/content/models';
import { defineComponent, onMounted, PropType, ref } from 'vue';
import { getCultureSettings } from '@/project/content/api/contentApi';

export default defineComponent({
    name: 'CookieBlock',
    props: {
        model: {
            required: true,
            type: Object as PropType<CookieBlock>,
        },
    },
    setup() {
        const culture = ref('');

        onMounted(async() => {
            const settings = await getCultureSettings();
            culture.value = settings.cultureNameForCookieBot.split('-')[0] || '';

            // This is done to circumvent that cookiebot doesn't support Åland as language
            if (culture.value.toLowerCase() === 'tt') {
                // Lazy-load Åland translations only when needed
                const { default: aalandCookieTranslationsScript } = await import('@/project/scripts/AalandCookieTranslations.js');
                aalandCookieTranslationsScript.waitForCookieDeclaration();
            }
        });

        return {
            culture,
        };
    },
});
</script>

<style lang="postcss">
 #CookieDeclarationChangeConsentChange, #CookieDeclarationChangeConsentWithdraw {
     text-decoration: underline !important;
     font-weight: bold !important;
     @apply text-pink-100 !important;
}
</style>
